"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var fastMemoize_1 = __importDefault(require("../../utils/fastMemoize"));
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.isNavigationReady = reselect_1.createSelector(moduleState, function (state) { return state.isNavigationReady; });
exports.epgDaysLoaded = reselect_1.createSelector(moduleState, function (state) { return state.epgDaysLoaded; });
exports.getEpgDay = reselect_1.createSelector(moduleState, function (state) {
    return fastMemoize_1.default(function (dayCode) { return state.epgDaysLoaded[dayCode]; });
});
//# sourceMappingURL=selectors.js.map